module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/payrollHistory/Item.ejs -->\n<div class="ibox float-e-margins payroll-history-item\n    payroll-status-'+
((__t=( model.get('status') ))==null?'':_.escape(__t))+
'">\n    <div class="ibox-title">\n        '+
((__t=( model.getPeriodFormatted() ))==null?'':_.escape(__t))+
'\n        <span class="label pull-right\n            '+
((__t=(
                model.get('status') < 3 ? 'label-default' :
                model.get('status') === 9 ? 'label-primary' :
                    'label-warning'
            ))==null?'':_.escape(__t))+
'">\n            '+
((__t=(
                model.getStatusLabel()
            ))==null?'':_.escape(__t))+
'\n        </span>\n    </div>\n    <div class="ibox-content">\n        <div class="row">\n            <div class="col-xs-5 total">\n                <h2>\n                    '+
((__t=( model.get('payslips') ))==null?'':_.escape(__t))+
'\n                </h2>\n                Employees\n            </div>\n            <div class="col-xs-7 total">\n                <h2>\n                    RM '+
((__t=( model.get('grossPay').formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                </h2>\n                Gross\n            </div>\n        </div>\n    </div>\n    <div class="ibox-content summary">\n        <div class="row">\n            <div class="col-xs-3 tax-total">\n                <h3>Total PCB</h3>\n                <h3>'+
((__t=( pcb ))==null?'':_.escape(__t))+
'</h3>\n            </div>\n            <div class="col-xs-3 tax-total">\n                <h3>Total EPF</h3>\n                <h3>'+
((__t=( epf ))==null?'':_.escape(__t))+
'</h3>\n            </div>\n            <div class="col-xs-3 tax-total">\n                <h3>Total SOCSO</h3>\n                <h3>'+
((__t=( socso ))==null?'':_.escape(__t))+
'</h3>\n            </div>\n            <div class="col-xs-3 tax-total">\n                <h3>Total EIS</h3>\n                <h3>\n                    '+
((__t=( eis ))==null?'':_.escape(__t))+
'\n                </h3>\n            </div>\n        </div>\n\n        <div class="m-t">\n            ';
  if (model.get('status') > 0) {  
__p+='\n                <h3>\n                    <a href="#payroll/view/'+
((__t=( model.id ))==null?'':_.escape(__t))+
'/summary">\n                        <i class="fa fa-table" aria-hidden="true"></i>\n                        Payroll Summary Report\n                    </a>\n                </h3>\n                <h3 class="m-t-xs">\n                    <a href="#payroll/view/'+
((__t=( model.id ))==null?'':_.escape(__t))+
'/payslips">\n                        <i class="fa fa-th-list" aria-hidden="true"></i>\n                        Payslips\n                    </a>\n                </h3>\n            ';
  } else { 
__p+='\n                <h3><i class="fa fa-table" aria-hidden="true"></i>\n                    <span class="disabled">Payroll Summary Report</span>\n                </h3>\n                <h3 class="m-t-xs">\n                    <i class="fa fa-th-list" aria-hidden="true"></i>\n                    <span class="disabled">Payslips</span>\n                </h3>\n            ';
  } 
__p+='\n        </div>\n    </div>\n    <div class="ibox-content receipts">\n        <div class="row clearfix">\n            <div class="pull-left">\n                ';
 if (!(company.get('isManaged') === false
                    && model.get('status') <= 3)) {  
__p+='\n                <i class="fa icon\n                    '+
((__t=( model.get('status') <= 1
                        && model.get('paymentType') === '2'?
                            'fa-calendar' :
                        model.get('status') <= 3 ?
                            'fa-bicycle' :
                        model.get('status') <= 7 ?
                            'fa-university' :
                            'fa-check-square-o'
                    ))==null?'':_.escape(__t))+
'">\n                </i>\n                ';
 }  
__p+='\n            </div>\n            <div class="">\n                <div class="status status-unsubmitted status-submitted">\n                    ';
 if (model.get('status') < 9
                        && model.get('paymentType') === '2') { 
__p+='\n                        <h3>Picking Up Cheques On:</h3>\n                        <h4>\n                            '+
((__t=( model.getFormatted(
                                'chequePickupDate', 'dddd, D MMMM'
                            ) || ' - ' ))==null?'':_.escape(__t))+
'\n                        </h4>\n                    ';
 } else if (model.get('status') > 8) { 
__p+='\n                        <h3>Payroll Submitted On:</h3>\n                        <h4>\n                            '+
((__t=( model.getFormatted(
                                'submittedDate', 'dddd, D MMMM'
                            ) || ' - ' ))==null?'':_.escape(__t))+
'\n                        </h4>\n                    ';
 } 
__p+='\n                </div>\n            </div>\n        </div>\n\n        ';
 if (company.get('isManaged') !== false && receipts.length > 0) {  
__p+='\n        <div class="receipt-links\n            '+
((__t=( model.get('status') < 9 ? 'disabled' : '' ))==null?'':_.escape(__t))+
'">\n            <h3>Receipts:</h3>\n            <div class="row">\n                <ul>\n                    ';
 receipts.forEach(function(attachment) { 
__p+='\n                    <li>\n                        <a href="'+
((__t=( attachment.getUrl() ))==null?'':_.escape(__t))+
'" target="_blank">\n                            '+
((__t=( attachment.get('description') ))==null?'':_.escape(__t))+
'\n                            <span class="small">\n                                ('+
((__t=( attachment.get('name') ))==null?'':_.escape(__t))+
')\n                            </span>\n                        </a>\n                    </li>\n                    ';
 }) 
__p+='\n                </ul>\n            </div>\n        </div>\n        ';
 } 
__p+='\n\n        <div class="row m-t-lg text-right">\n            <div class="col-xs-12">\n                ';
 if (showFinishButton) { 
__p+='\n                    <button class="btn btn-outline btn-success\n                        btn-continue-payroll js-finish-payroll"\n                            data-loading-text="Submitting...">\n                        <i class="fa fa-arrow-circle-left"></i>\n                        Finish Payroll\n                    </button>\n                ';
 } 
__p+='\n\n\n                ';
 if (model.get('status') === 3) { 
__p+='\n                    <button class="btn btn-outline btn-warning\n                        btn-cancel-payroll js-cancel-payroll"\n                        data-loading-text="Cancelling...">\n                        <i class="fa fa-exclamation-triangle"></i>\n                        Cancel Payroll\n                    </button>\n                ';
 } 
__p+='\n\n                ';
 if (model.get('status') < 3) { 
__p+='\n                    <a href="#payroll"\n                        class="btn btn-outline btn-success\n                            btn-continue-payroll"\n                        data-toggle="tooltip"\n                        data-title="Proceed running payroll for current month"\n                        data-placement="top" data-delayed>\n                        <i class="fa fa-arrow-circle-left"></i>\n                        Continue Payroll\n                    </a>\n                ';
 } 
__p+='\n\n                ';
 if (
                    model.get('status') === 3 &&
                    model.get('paymentType') === '2' &&
                    !model.get('chequePickupDate')
                ) { 
__p+='\n                    <button\n                        class="btn btn-outline btn-success js-set-date">\n                        <i class="fa fa-calendar"></i>\n                        Set Date\n                    </button>\n                ';
 } 
__p+='\n\n                ';
 if (showSyncButton) { 
__p+='\n                    <button class="btn btn-outline btn-success js-sync">\n                        <i class="fa fa-refresh"></i>\n                        Sync with '+
((__t=( integrationProvider ))==null?'':_.escape(__t))+
'\n                    </button>\n                ';
 } 
__p+='\n                ';
 if (lastSyncAt) { 
__p+='\n                    Last Sync at: '+
((__t=( lastSyncAt ))==null?'':_.escape(__t))+
'\n                ';
 } 
__p+='\n\n                ';
 if (model.get('status') === 9) { 
__p+='\n                    ';
 if (archive) { 
__p+='\n                        <button class="btn btn-outline btn-success js-send-payslips">\n                            <i class="fa fa-envelope-o"></i>\n                            Send Payslips\n                        </button>\n                    ';
 } else { 
__p+='\n                        <button class="btn btn-outline btn-success">\n                            <i class="fa fa-envelope-o"></i>\n                            Not ready\n                        </button>\n                    ';
 } 
__p+='\n                    <a class="btn btn-outine btn-primary js-download-payroll">\n                        <i class="fa fa-download"></i>\n                        '+
((__t=( archive ?
                            'Download' : 'Not ready' ))==null?'':_.escape(__t))+
'\n                    </a>\n                ';
 } 
__p+='\n            </div>\n        </div>\n    </div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/payrollHistory/Item.ejs
// module id = 763
// module chunks = 1